var render, staticRenderFns
import script from "./SelfieVerification.vue?vue&type=script&lang=js"
export * from "./SelfieVerification.vue?vue&type=script&lang=js"
import style0 from "./SelfieVerification.vue?vue&type=style&index=0&id=54ef7a72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports